module.exports = __webpack_public_path__ + "static/media/lots-icon.ed9b420f.svg";